import { useEffect, useState } from 'react'
// import {
//     SelectOption as Option,
// } from '@iso/components/uielements/select';
// import Select from '../../Deployments/Deployment.styles';
import Button from '@iso/components/uielements/button';
import Box from '@iso/components/utility/box';
// import ContentHolder from '@iso/components/utility/contentHolder';
// import { Textarea } from '@iso/components/uielements/input';
// import DrawerRoot from '../../ScrumBoard/rootDrawer';
import { Input, Form, Spin } from 'antd';
import { useContext } from 'react';
import { AppContext } from '../../../context/ContextProvider';
import { useLocation, useNavigate } from 'react-router-dom';
import LayoutWrapper from '../../../components/utility/layoutWrapper';
import CreateTaskFooter from '../../ScrumBoard/Task/TaskCreateOrUpdate/CreateTaskFooter/CreateTaskFooter';
import CreateTaskHeader from '../../ScrumBoard/Task/TaskCreateOrUpdate/CreateTaskHeader/CreateTaskHeader';
import { StickerWidgetWrapper } from '../../Widgets/SmallCards/SmallCards.styles';
// import { BreadcrumbContext } from '../../../context/breadcrumbContext';
// import plusIcon from '../../../assets/images/plusIcon.svg';
// import { Link } from 'react-router-dom';
// import deleteIcon from '../../../assets/images/tagsDelete.svg';
// import api from '../../../api';
// import { enums, formatErrors, myClusterStatus, nodegroupStatuses } from '../../../context/helper';
// import Alert from '@iso/components/Feedback/Alert';
// import { AlertContext } from '../../../context/alertContext';
// import { PlusOutlined } from '@ant-design/icons';


//const Option = SelectOption;

let boxStyle = {
    border: "transparent",
    width: "fit-content",
    padding: "0",
    margin: "0",
    height: "fit-content",
    width: "100%",
}

let boxTitleStyle = {
    color: "#1f1f1f",
    fontFamily: "Poppins",
    fontType: "medium",
    fontWeight: "500",
    fontSize: "14px",
    lineHeight: "20px",
    marginBottom: "1px",
};

let boxSubtitleStyle = {
    fontSize: "12px",
    lineHeight: "20px",
    color: "#9b9b9b",
    fontFamily: "Nunito Sans",
    fontWeight: "400",
    fontType: "regular",
}

const widgetStyle = {
    margin: "20px",
    width: "100%",
};

export default function WorkflowConfiguration({ columnId }) {

    // const navigate = useNavigate();
    // const location = useLocation();
    const [form] = Form.useForm();

    let { currentWorkflowData, setCurrentWorkflowData, setOpenRightDrawer, checkTryWithoutLogin } = useContext(AppContext);

    // let { pageHeading, setPageHeading, pageHeadingsObj, setPageHeadingsObj, setBreadData, breadcrumbObj } = useContext(BreadcrumbContext);

    // const { alertOptions, set_alertOptions } = useContext(AlertContext);

    const [workflowConfiguration, setWorkflowConfiguration] = useState({
        minCpu: currentWorkflowData?.resourceData?.minCpu ? currentWorkflowData.resourceData.minCpu : "500",
        maxCpu: currentWorkflowData?.resourceData?.maxCpu ? currentWorkflowData.resourceData.maxCpu : "1000",
        minRam: currentWorkflowData?.resourceData?.minRam ? currentWorkflowData.resourceData.minRam : "1024",
        maxRam: currentWorkflowData?.resourceData?.maxRam ? currentWorkflowData.resourceData.maxRam : "2048",
        cpuUnit: currentWorkflowData?.resourceData?.cpuUnit ? currentWorkflowData.resourceData.cpuUnit : "m",
        memoryUnit: currentWorkflowData?.resourceData?.memoryUnit ? currentWorkflowData.resourceData.memoryUnit : "Mi",
    });

    // useEffect(() => {
    //     if(currentWorkflowData?.resourceData) {
    //         setWorkflowConfiguration({
    //             minCpu: currentWorkflowData?.resourceData?.minCpu ? currentWorkflowData.resourceData.minCpu : "500",
    //             maxCpu: currentWorkflowData?.resourceData?.maxCpu ? currentWorkflowData.resourceData.maxCpu : "1000",
    //             minRam: currentWorkflowData?.resourceData?.minRam ? currentWorkflowData.resourceData.minRam : "1024",
    //             maxRam: currentWorkflowData?.resourceData?.maxRam ? currentWorkflowData.resourceData.maxRam : "2048",
    //             cpuUnit: currentWorkflowData?.resourceData?.cpuUnit ? currentWorkflowData.resourceData.cpuUnit : "m",
    //             memoryUnit: currentWorkflowData?.resourceData?.memoryUnit ? currentWorkflowData.resourceData.memoryUnit : "Mi",
    //         });
    //     }
    // }, [currentWorkflowData?.resourceData]);

    const handleChange = (e) => {
        setWorkflowConfiguration({ ...workflowConfiguration, [e.target.name]: e.target.value });

        // if( e.target.name === "minCpu" || e.target.name === "maxCpu") {
        //     form.setFieldsValue({
        //         ...workflowConfiguration,
        //         [e.target.name]: e.target.value,
        //     });
        // }
        form.setFieldsValue({
            ...workflowConfiguration,
            [e.target.name]: e.target.value,
        });
    };

    const handleSaveDetails = async () => {
        try {
            const values = await form.validateFields();
            console.log('Success:', values);

            setCurrentWorkflowData((prev) => {
                localStorage.setItem("Workflow", JSON.stringify({...prev, resourceData: {...workflowConfiguration}}));

                return {
                    ...prev,
                    resourceData: {...workflowConfiguration}
                };

            });
            
            handleCancel();
        }
        catch (err) {
            console.log("Found error in workflow config :", err);
        }
        
    };
    
    const handleCancel = (e) => {
        setOpenRightDrawer({
            drawerType: false,
            drawerProps: {
                data: "",
            },
        });
    }


    return (
        <>
            <LayoutWrapper className="clusterInfo" style={{ padding: "0" }}>
                <CreateTaskHeader buttonContent={columnId} onCancel={handleCancel} />
                <div style={{ marginTop: "84px", width: "100%" }} />

                <StickerWidgetWrapper className="isoStickerWidget" style={{ ...widgetStyle, marginTop: "20px" }}>
                    <Form
                        form={form}
                        initialValues={{ ...workflowConfiguration }}
                        preserve={false}
                        name="dynamic_rule"
                        style={{
                            width: "100%",
                        }}
                    >
                        <Box
                            title={"Min CPU*"}
                            subtitle={"Please provide min cpu."}
                            titleStyle={boxTitleStyle}
                            subtitleStyle={boxSubtitleStyle}
                            style={{ ...boxStyle, position: "relative" }}
                        >
                            <Form.Item
                                name="minCpu"
                                rules={[
                                    {
                                        required: true,
                                        message: 'This field is required!',
                                    },
                                    {
                                        // Custom validator for only integers
                                        validator: (_, value) => {
                                            if (value && value < 100) {
                                                return Promise.reject(new Error(`Min cpu should be greater than or equals to 100.`));
                                            }
                                            else if (value && value >= 100 && (parseInt(value) > parseInt(workflowConfiguration.maxCpu))) {
                                                return Promise.reject(new Error(`Min cpu should be less than or equals to max cpu.`));
                                            }
                                            else {
                                                return Promise.resolve();
                                            }
                                        }
                                    },
                                ]}
                            >
                                <Input
                                    data-testid="app-workflow-config-min-cpu-input"
                                    placeholder="500"
                                    value={workflowConfiguration.minCpu}
                                    name="minCpu"
                                    type='number'
                                    onChange={handleChange}
                                    onBlur={async (e) => {
                                        try{
                                            await form.validateFields(["maxCpu"])
                                        }
                                        catch(err) {
                                            console.log("Error in validating max cpu :", err);
                                        }
                                    }}
                                    style={{ height: "44px" }}
                                    suffix="m"
                                />
                            </Form.Item>
                        </Box>

                        <Box
                            title={"Max CPU*"}
                            subtitle={"Please provide max cpu."}
                            titleStyle={boxTitleStyle}
                            subtitleStyle={boxSubtitleStyle}
                            style={{ ...boxStyle, position: "relative" }}
                        >
                            <Form.Item
                                name="maxCpu"
                                rules={[
                                    {
                                        required: true,
                                        message: 'This field is required!',
                                    },
                                    {
                                        // Custom validator for only integers
                                        validator: (_, value) => {
                                            if (value && value < 100) {
                                                return Promise.reject(new Error(`Max cpu should be greater than or equals to 100.`));
                                            }
                                            else if (value && value >= 100 && (parseInt(value) < parseInt(workflowConfiguration.minCpu))) {
                                                return Promise.reject(new Error(`Max cpu should be greater than or equals to min cpu.`));
                                            }
                                            else {
                                                return Promise.resolve();
                                            }
                                        }
                                    },
                                ]}
                            >
                                <Input
                                    data-testid="app-workflow-config-max-cpu-input"
                                    placeholder="1000"
                                    value={workflowConfiguration.maxCpu}
                                    name="maxCpu"
                                    type='number'
                                    onChange={handleChange}
                                    onBlur={async (e) => {
                                        try{
                                            await form.validateFields(["minCpu"])
                                        }
                                        catch(err) {
                                            console.log("Error in validating min cpu :", err);
                                        }
                                    }}
                                    style={{ height: "44px" }}
                                    suffix="m"
                                />
                            </Form.Item>
                        </Box>

                        <Box
                            title={"Min RAM*"}
                            subtitle={"Please provide min ram."}
                            titleStyle={boxTitleStyle}
                            subtitleStyle={boxSubtitleStyle}
                            style={{ ...boxStyle, position: "relative" }}
                        >

                            <Form.Item
                                name="minRam"
                                rules={[
                                    {
                                        required: true,
                                        message: 'This field is required!',
                                    },
                                    {
                                        // Custom validator for only integers
                                        validator: (_, value) => {
                                            console.log("value in min ram :", value, workflowConfiguration.maxRam);
                                            if (value && value < 100) {
                                                return Promise.reject(new Error(`Min ram should be greater than or equals to 100.`));
                                            }
                                            else if (value && value >= 100 && parseInt(value) > parseInt(workflowConfiguration.maxRam)) {
                                                return Promise.reject(new Error(`Min ram should be less than or equals to max ram.`));
                                            }
                                            else {
                                                return Promise.resolve();
                                            }
                                        }
                                    },
                                ]}
                            >
                                <Input
                                    data-testid="app-workflow-config-min-ram-input"
                                    placeholder="1024"
                                    value={workflowConfiguration.minRam}
                                    name="minRam"
                                    type='number'
                                    onChange={handleChange}
                                    onBlur={async (e) => {
                                        try{
                                            await form.validateFields(["maxRam"])
                                        }
                                        catch(err) {
                                            console.log("Error in validating max ram :", err);
                                        }
                                    }}
                                    style={{ height: "44px" }}
                                    suffix="Mi"
                                />
                            </Form.Item>
                        </Box>

                        <Box
                            title={"Max RAM*"}
                            subtitle={"Please provide max ram."}
                            titleStyle={boxTitleStyle}
                            subtitleStyle={boxSubtitleStyle}
                            style={{ ...boxStyle, position: "relative", marginBottom: "150px" }}
                        >
                            <Form.Item
                                name="maxRam"
                                rules={[
                                    {
                                        required: true,
                                        message: 'This field is required!',
                                    },
                                    {
                                        // Custom validator for only integers
                                        validator: (_, value) => {
                                            if (value && value < 100) {
                                                return Promise.reject(new Error(`Min ram should be greater than or equals to 100.`));
                                            }
                                            else if (value && value >= 100 && (parseInt(value) < parseInt(workflowConfiguration.minRam))) {
                                                return Promise.reject(new Error(`Max ram should be greater than or equals to min ram.`));
                                            }
                                            else {
                                                return Promise.resolve();
                                            }
                                        }
                                    },
                                ]}
                            >
                                <Input
                                    data-testid="app-workflow-config-max-ram-input"
                                    placeholder="2048"
                                    value={workflowConfiguration.maxRam}
                                    name="maxRam"
                                    type='number'
                                    onChange={handleChange}
                                    onBlur={async (e) => {
                                        try{
                                            await form.validateFields(["minRam"])
                                        }
                                        catch(err) {
                                            console.log("Error in validating min ram :", err);
                                        }
                                    }}
                                    style={{ height: "44px" }}
                                    suffix="Mi"
                                />
                            </Form.Item>
                        </Box>

                    </Form>
                </StickerWidgetWrapper>

                {!checkTryWithoutLogin && !currentWorkflowData?.fromPipeline && <CreateTaskFooter buttonContent={"Workflow Configuration"} givenButtonFunction1={handleSaveDetails} givenButtonFunction2={handleCancel} saveButtonTestId="app-workflow-config-save-button" cancelButtonTestId="app-workflow-config-cancel-button" />}
            </LayoutWrapper>
        </>
    )
};